import React from "react";
import { CompaniesCardLoading } from "./CompaniesCardLoading";
import UserListSkeleton from "./UserListSkeleton";
import CompanyDetailLoading from "./CompanyDetailLoading";
import FormSkeleton from "./FormSkeleton";
import DeshboardGrid from "./DeshboardGrid";
import GridLoading from "./GridLoading";
import JobInfoLoading from "./JobInfoLoading";
import ListSkeleton from "./ListSkeleton";
import LabelRowList from "./LabelRowList";
import BoxLoading from "./BoxLoading";
import Dashboard from "../employer/dashboard/Dashboard";
import DashboardSkeleton from "./DashboardSkeleton";

const DynamicSkeleton = ({ type, ...props }) => {
  const skeletonComponents = {
    companiesCard: CompaniesCardLoading,
    userList: UserListSkeleton,
    companyDetail: CompanyDetailLoading,
    form: FormSkeleton,
    dashboardGrid: DeshboardGrid,
    grid: GridLoading,
    jobInfo: JobInfoLoading,
    rowList: ListSkeleton,
    labelRowList: LabelRowList,
    squareBox: BoxLoading,
    dashboard:DashboardSkeleton
  };

  const SkeletonComponent = skeletonComponents[type];

  if (!SkeletonComponent) {
    console.warn(
      `Skeleton type "${type}" not found. Available types:`,
      Object.keys(skeletonComponents)
    );
    return null;
  }

  return Array.from({ length: props.limit ? props?.limit : 1 }).map((_, i) => (
    <SkeletonComponent {...props} key={i} />
  ));
};

export default DynamicSkeleton;
